/**
 * One CMS compare section (e.g. Portfolio tools): header + feature rows with
 * per-tier availability.
 */

import type { CompareFeatureRow, CompareSection } from '../../types/compare.types'
import {
  ELITE_PLANS_COMPARE_ELITE_CHECK_COLOR,
  ELITE_PLANS_COMPARE_PRIME_CHECK_COLOR
} from '../../constants/compareUi'
import { ElitePlansCompareAvailabilityIcon } from './ElitePlansCompareAvailabilityIcon'
import { availabilityLabel } from './compareAccordionHelpers'

export function ElitePlansCompareSectionCard({
  section
}: {
  section: CompareSection
  /** Reserved for row info sheet when product re-enables the affordance. */
  onFeatureInfo?: (row: CompareFeatureRow) => void
}) {
  return (
    <div className='overflow-hidden rounded-xl border border-[#EBF2F2] bg-white'>
      <div className='bg-gradient-to-r from-[#F6F9F9] to-white px-4 py-2'>
        <p className='text-[11px] font-medium uppercase tracking-[1px] text-[#6A6E6E]'>
          {section.title}
        </p>
      </div>
      <ul className='list-none p-0'>
        {section.rows.map((row) => (
          <li key={row.id} className='flex items-center justify-between gap-3 px-4 py-3'>
            <div className='flex min-w-0 items-center gap-1.5'>
              <span className='truncate text-[13px] font-medium leading-[1.3] text-[#232323]'>
                {row.label}
              </span>
            </div>
            <div className='flex shrink-0 items-center gap-[29px]'>
              <ElitePlansCompareAvailabilityIcon
                availability={row.free}
                checkColor={ELITE_PLANS_COMPARE_ELITE_CHECK_COLOR}
                label={`Free: ${availabilityLabel(row.free)}`}
              />
              <ElitePlansCompareAvailabilityIcon
                availability={row.elite}
                checkColor={ELITE_PLANS_COMPARE_ELITE_CHECK_COLOR}
                label={`Elite: ${availabilityLabel(row.elite)}`}
              />
              <ElitePlansCompareAvailabilityIcon
                availability={row.prime}
                checkColor={ELITE_PLANS_COMPARE_PRIME_CHECK_COLOR}
                label={`Prime: ${availabilityLabel(row.prime)}`}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
